import { Col, Row, Select } from "antd";
import { useContext } from "react";
import GlobalContext from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import logo from "../../assets/LogoMinistère.svg";
import republique from "../../assets/tunisia.png";
import logoSigaf from "../../assets/logo_sigaf_2.png";

const HeaderConnexion = () => {
  const { setGlobalData, globalData, setIsRtl } = useContext(GlobalContext);
  const { i18n } = useTranslation();
  const { Option } = Select;

  const handleLanguageChange = (value) => {
    localStorage.setItem("language", value);
    setGlobalData({
      ...globalData,
      language: value,
    });
    i18n.changeLanguage(value);
    setIsRtl(value === "ar");
  };
  return (
    <Col
      lg={24}
      style={{
        marginBottom: "4rem",
        display: "flex",
        justifyContent: "space-around",
        backgroundColor: "white",
        width: "100%",
        padding: "1rem",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "90%",
          alignItems: "center",
        }}
      >
        <Col>
          <img
            src={logoSigaf}
            style={{ width: "8rem" }}
            alt="logo"
          />
        </Col>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem", // Adds spacing between elements
          }}
        >
          <Select
            style={{ width: "8rem" }}
            onChange={handleLanguageChange}
            value={localStorage.getItem("language") || "fr"}
          >
            <Option value="fr">Français</Option>
            <Option value="ar">العربية</Option>
          </Select>
          <img src={logo} style={{ height: "90px" }} alt="logo" />
          <img src={republique} style={{ height: "86px" }} alt="republique" />
        </Col>
      </Row>
    </Col>
  );
};

export default HeaderConnexion;
